import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Navbar, Footer } from "./components/Layout";
import { Toaster } from "./components/ui/sonner";

// Pages
import HomePage from "./pages/HomePage";
import RecipesPage from "./pages/RecipesPage";
import RecipeDetailPage from "./pages/RecipeDetailPage";
import AIGeneratorPage from "./pages/AIGeneratorPage";
import FavoritesPage from "./pages/FavoritesPage";
import LoginPage from "./pages/LoginPage";
import AuthCallback from "./pages/AuthCallback";
import MemberAreaPage from "./pages/MemberAreaPage";
import AdminPage from "./pages/AdminPage";
import AdminRecipesPage from "./pages/AdminRecipesPage";
import HelpPage from "./pages/HelpPage";
import SetPasswordPage from "./pages/SetPasswordPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import InstallAppPage from "./pages/InstallAppPage";

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id - handle OAuth callback
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/recipes" element={<RecipesPage />} />
      <Route path="/recipes/:id" element={<RecipeDetailPage />} />
      <Route path="/ai-generator" element={<AIGeneratorPage />} />
      <Route path="/favorites" element={<FavoritesPage />} />
      <Route path="/member" element={<MemberAreaPage section="all" />} />
      <Route path="/magicka-patka" element={<MemberAreaPage section="magicka-patka" />} />
      <Route path="/tematicke-kolekcie" element={<MemberAreaPage section="tematicke-kolekcie" />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/admin/recipes" element={<AdminRecipesPage />} />
      <Route path="/help" element={<HelpPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/set-password" element={<SetPasswordPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/install-app" element={<InstallAppPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
    </Routes>
  );
}

function AppContent() {
  const location = useLocation();
  
  // Don't show navbar/footer on auth callback
  const isAuthCallback = location.pathname === '/auth/callback' || location.hash?.includes('session_id=');

  return (
    <div className="flex flex-col min-h-screen">
      {!isAuthCallback && <Navbar />}
      <main className="flex-1">
        <AppRouter />
      </main>
      {!isAuthCallback && <Footer />}
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
